"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Webauthn = void 0;
const tslib_1 = require("tslib");
const Error_1 = require("../shared/Error");
const Util_1 = require("../shared/Util");
class Webauthn {
    browserSupportsWebauthn() {
        if (navigator.credentials &&
            (window === null || window === void 0 ? void 0 : window.PublicKeyCredential) !== undefined &&
            typeof window.PublicKeyCredential === "function") {
            return true;
        }
        else
            return false;
    }
    registerWebauthn(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const creationOptions = {
                    publicKey: {
                        rp: params.rp,
                        user: {
                            name: params.user.name,
                            displayName: params.user.displayName,
                            id: Util_1.Util.toArrayBuffer(params.user.id),
                        },
                        pubKeyCredParams: params.pubKeyCredParams,
                        challenge: Util_1.Util.toArrayBuffer(params.challenge),
                        authenticatorSelection: params.authenticatorSelection,
                        attestation: params.attestation,
                    },
                };
                const credential = (yield navigator.credentials.create(creationOptions));
                if (!credential) {
                    return Promise.reject(new Error(Error_1.CustomerAuthnError.INTERNAL_ERROR));
                }
                else {
                    const response = credential.response;
                    const result = {
                        id: credential.id,
                        rawId: Util_1.Util.toBase64Url(credential.rawId),
                        response: {
                            clientDataJSON: Util_1.Util.toBase64Url(response.clientDataJSON),
                            attestationObject: Util_1.Util.toBase64Url(response.attestationObject),
                        },
                        type: "public-key",
                    };
                    return Promise.resolve(result);
                }
            }
            catch (error) {
                return Promise.reject(this.convertToCustomerAuthnError(error));
            }
        });
    }
    challengeWebauthn(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const credentialOptions = {
                    publicKey: {
                        rpId: params.rpId,
                        allowCredentials: params.allowCredentials.map(cred => ({
                            id: Util_1.Util.toArrayBuffer(cred.id),
                            type: cred.type,
                        })),
                        timeout: params.timeout,
                        challenge: Util_1.Util.toArrayBuffer(params.challenge),
                    },
                };
                const credential = (yield navigator.credentials.get(credentialOptions));
                if (!credential) {
                    return Promise.reject(new Error(Error_1.CustomerAuthnError.INTERNAL_ERROR));
                }
                const response = credential.response;
                const signResult = {
                    id: credential.id,
                    rawId: Util_1.Util.toBase64Url(credential.rawId),
                    response: {
                        userHandle: Util_1.Util.toBase64Url(response.userHandle || ""),
                        clientDataJSON: Util_1.Util.toBase64Url(response.clientDataJSON),
                        authenticatorData: Util_1.Util.toBase64Url(response.authenticatorData),
                        signature: Util_1.Util.toBase64Url(response.signature),
                    },
                    type: "public-key",
                };
                return signResult;
            }
            catch (error) {
                return Promise.reject(this.convertToCustomerAuthnError(error));
            }
        });
    }
    convertToCustomerAuthnError(error) {
        if (error instanceof Error) {
            if (error.name && (error.name === "NotAllowedError" || error.name === "AbortError")) {
                return new Error(Error_1.CustomerAuthnError.REJECTED);
            }
            else if (error.name === "NotSupportedError") {
                return new Error(Error_1.CustomerAuthnError.NOT_SUPPORTED);
            }
            else {
                return new Error(Error_1.CustomerAuthnError.INTERNAL_ERROR);
            }
        }
        else {
            return new Error(Error_1.CustomerAuthnError.INTERNAL_ERROR);
        }
    }
}
exports.Webauthn = Webauthn;
//# sourceMappingURL=Webauthn.js.map